import { LinkBox, LinkOverlay, VStack } from '@chakra-ui/react'
import { CoverImage } from '@!/Store/Common/components/CoverImage'

export const Title = ({ titleId, titleName, imageUrl, gtmClick }) => {
  return (
    <LinkBox w="100px">
      <VStack>
        <CoverImage src={imageUrl} alt={titleName} objectFit="contain" width="100px" />
        <LinkOverlay
          href={`/store/books?book_title_id=${titleId}`}
          lineClamp={1}
          fontSize="sm"
          fontWeight="bold"
          width="100%"
          {...(gtmClick && { 'data-gtm-click': gtmClick })}
        >
          {titleName}
        </LinkOverlay>
      </VStack>
    </LinkBox>
  )
}
